import { useEffect } from "react";
import { useSEO } from "../components/seo";

interface PageSEOProps {
  title?: string;
  description?: string;
  image?: string;
  article?: boolean;
}

/**
 * Hook for individual pages to set their own SEO data
 * This will override the route-based SEO data from useSEOByRoute
 */
export const usePageSEO = ({
  title,
  description,
  image,
  article,
}: PageSEOProps) => {
  const { updateSEO } = useSEO();

  useEffect(() => {
    // Only update SEO if at least one property is provided
    if (title || description || image || article !== undefined) {
      updateSEO({
        title,
        description,
        image,
        article,
      });
    }
  }, [title, description, image, article, updateSEO]);
};

export default usePageSEO;
